import React, { useState } from 'react';
import styles from './style.module.css';

const FileMessage = ({ base64Content, fileName, fileType }) => {
    const [showPreview, setShowPreview] = useState(false);
    const [error, setError] = useState(false);

    const detectFileType = (base64) => {
        if (!base64) return 'unknown';
        
        if (base64.startsWith('data:')) {
            const mimeType = base64.split(';')[0].split(':')[1];
            return mimeType;
        }
        
        // Detectar tipo baseado no header do base64
        const header = base64.substring(0, 20);
        
        // Imagens
        if (header.includes('iVBORw0KGgo') || header.includes('/9j/')) {
            return 'image';
        }
        
        // PDFs - verificar assinatura PDF
        if (header.includes('JVBERi0x') || base64.startsWith('JVBERi0x')) {
            return 'application/pdf';
        }
        
        // Documentos Office
        if (header.includes('UEsDBBQ') || header.includes('PK')) {
            return 'document';
        }
        
        return 'unknown';
    };

    const getFileExtension = (fileName, detectedType) => {
        if (fileName && fileName.includes('.')) {
            return fileName.split('.').pop().toLowerCase();
        }
        
        switch (detectedType) {
            case 'image/jpeg':
            case 'image/jpg':
                return 'jpg';
            case 'image/png':
                return 'png';
            case 'image/gif':
                return 'gif';
            case 'application/pdf':
                return 'pdf';
            case 'application/msword':
                return 'doc';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'docx';
            default:
                return 'file';
        }
    };

    const renderPreview = () => {
        const detectedType = detectFileType(base64Content);
        const extension = getFileExtension(fileName, detectedType);
        
        if (detectedType.startsWith('image/') || detectedType === 'image') {
            return (
                <div className={styles.imagePreview}>
                    <img 
                        src={base64Content.startsWith('data:') ? base64Content : `data:image/${extension};base64,${base64Content}`}
                        alt={fileName || 'Imagem'}
                        onError={() => setError(true)}
                        className={styles.previewImage}
                    />
                </div>
            );
        }
        
        return (
            <div className={styles.filePreview}>
                <div className={styles.fileIcon}>
                    {extension === 'pdf' && '📄'}
                    {(extension === 'doc' || extension === 'docx') && '📝'}
                    {(extension === 'xls' || extension === 'xlsx') && '📊'}
                    {(extension === 'ppt' || extension === 'pptx') && '📊'}
                    {!['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension) && '📎'}
                </div>
                <div className={styles.fileInfo}>
                    <span className={styles.fileName}>{fileName || `arquivo.${extension}`}</span>
                    <span className={styles.fileType}>{extension.toUpperCase()}</span>
                </div>
            </div>
        );
    };

    const handleDownload = () => {
        try {
            const detectedType = detectFileType(base64Content);
            const extension = getFileExtension(fileName, detectedType);
            const finalFileName = fileName || `arquivo.${extension}`;
            
            let dataUrl = base64Content;
            
            // Se não começar com 'data:', construir o data URL apropriado
            if (!base64Content.startsWith('data:')) {
                let mimeType = 'application/octet-stream'; // Padrão
                
                // Determinar o MIME type correto baseado no tipo de arquivo
                if (detectedType.startsWith('image/')) {
                    mimeType = detectedType;
                } else if (extension === 'pdf') {
                    mimeType = 'application/pdf';
                } else if (extension === 'doc') {
                    mimeType = 'application/msword';
                } else if (extension === 'docx') {
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                } else if (extension === 'xls') {
                    mimeType = 'application/vnd.ms-excel';
                } else if (extension === 'xlsx') {
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                }
                
                dataUrl = `data:${mimeType};base64,${base64Content}`;
            }
            
            console.log('Download iniciado:', {
                fileName: finalFileName,
                mimeType: dataUrl.split(';')[0].split(':')[1],
                dataUrlLength: dataUrl.length
            });
            
            // Criar elemento de download
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = finalFileName;
            link.style.display = 'none';
            
            // Adicionar ao DOM, clicar e remover
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            console.log('Download concluído com sucesso');
        } catch (err) {
            console.error('Erro ao fazer download:', err);
            alert('Erro ao fazer download do arquivo. Tente novamente.');
        }
    };

    if (error) {
        return (
            <div className={styles.errorContainer}>
                <span className={styles.errorIcon}>⚠️</span>
                <span className={styles.errorText}>Erro ao carregar arquivo</span>
            </div>
        );
    }

    return (
        <div className={styles.fileMessageContainer}>
            <div 
                className={styles.fileThumbnail}
                onClick={() => setShowPreview(!showPreview)}
            >
                {renderPreview()}
            </div>
            
            {showPreview && (
                <div className={styles.previewModal} onClick={() => setShowPreview(false)}>
                    <div className={styles.previewContent} onClick={(e) => e.stopPropagation()}>
                        <button 
                            className={styles.closeButton}
                            onClick={() => setShowPreview(false)}
                        >
                            ×
                        </button>
                        <div className={styles.previewBody}>
                            {renderPreview()}
                        </div>
                        <div className={styles.previewActions}>
                            <button 
                                className={styles.downloadButton}
                                onClick={handleDownload}
                            >
                                📥 Download
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FileMessage;
